// PaymentFailPage.tsx

// PaymentSuccessPage.tsx
import { Button, Container, Grid, Link } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Banner from '../Banner';

const PaymentFailPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message');
  const navigate = useNavigate();

  
  // Prevent going back to previous history entry (like the payment page) 
  useEffect(() => {
    // Push current state so we trap “back”
    window.history.pushState(null, '', window.location.href);

    const onPopState = (e) => {
      // When user presses back, redirect them to a safe page
      // For example: login page or home
      if (id) {
        navigate(`/register/${id}`, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    };

    window.addEventListener('popstate', onPopState);

    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, [navigate, id]);

  const retry = () => {
        navigate(`/register/${id}`, { replace: true });
    // navigate(-1); // go back maybe to payment page or registration
  };

  return (
       <>
        
          <Banner />
              <Container sx={{ mt: 2 }}>
                      <Grid
                        container
                        spacing={5}
                        alignItems="center"
                        justifyContent="center"
                        py={1}
                      >
    
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                  <h2>Payment Failed / Cancelled</h2>
                  <p>Unfortunately, your transaction could not be completed at this time.<br/> Please try again or use an alternate payment method.</p>
                 <p>
                  
                  Go to <Link onClick={retry}   style={{
      cursor: "pointer",
      color: "#1976d2",
      textDecoration: "underline",
    }}>Create an Account</Link> Page
                  </p>
                </div>
                      </Grid>
                      </Container>
    </>
  );
};

export default PaymentFailPage;